export const reportsConstants = {
  GET_CAMPAIGNS_REQUEST: "GET_CAMPAIGNS_REQUEST",
  GET_CAMPAIGNS_FAILURE: "GET_CAMPAIGNS_FAILURE",
  GET_CAMPAIGNS_SUCCESS: "GET_CAMPAIGNS_SUCCESS",
  GET_SALES_BY_DOMAIN_REQUEST: "GET_SALES_BY_DOMAIN_REQUEST",
  GET_SALES_BY_DOMAIN_FAILURE: "GET_SALES_BY_DOMAIN_FAILURE",
  GET_SALES_BY_DOMAIN_SUCCESS: "GET_SALES_BY_DOMAIN_SUCCESS",
};
